import { ReleaseAndDeployments } from '@agilelab/plugin-wb-builder-common';
import { TableCellProps } from '@agilelab/plugin-wb-platform';
import {
  ReleaseActions,
  ReleaseCreatedBy,
  ReleaseDeploymentStatus,
  ReleaseName,
  ReleaseUpdate,
} from '../ReleaseTableColumns';

export function useReleasesTableColumns(): TableCellProps<ReleaseAndDeployments>[] {
  return [
    {
      field: 'release' as keyof ReleaseAndDeployments,
      fieldRender: field => <ReleaseName release={field} />,
      headerName: 'Release',
      sortable: true,
    },
    {
      field: 'update' as keyof ReleaseAndDeployments,
      fieldRender: field => <ReleaseUpdate release={field} />,
      headerName: 'Update',
      sortable: true,
    },
    {
      field: 'createdBy' as keyof ReleaseAndDeployments,
      fieldRender: field => <ReleaseCreatedBy release={field} />,
      headerName: 'Created By',
      sortable: true,
    },
    {
      field: 'deploymentStatus' as keyof ReleaseAndDeployments,
      fieldRender: field => <ReleaseDeploymentStatus release={field} />,
      headerName: 'Deployment Status',
      sortable: false,
    },
    {
      field: 'actions' as keyof ReleaseAndDeployments,
      fieldRender: field => <ReleaseActions release={field} />,
      headerName: '',
      width: 280,
      minWidth: 280,
      maxWidth: 280,
      resizable: false,
      sortable: false,
    },
  ];
}
